import {
  processingSessionIdFormat,
  processingSessionItemIdFormat,
} from "@redotech/redo-return-id";
import * as z from "zod";
import { ProcessingSession } from "./processing-session";

export const resolveItemReviewFailures = {
  name: "resolveItemReviewFailures" as const,
  input: z.object({
    sessionId: processingSessionIdFormat.schema,
    sessionItemIds: z.array(processingSessionItemIdFormat.schema).min(1),
  }),
  output: z.object({ session: ProcessingSession }),
};
